module.exports = __webpack_public_path__ + "assets/img/8.45d1fb53.png";